import * as React from 'react';
import type { SVGProps } from 'react';
interface SVGRProps {
  title?: string;
  titleId?: string;
}
const SvgFilter = ({ title, titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps) => (
  <svg
    width={24}
    height={24}
    viewBox='0 0 24 24'
    xmlns='http://www.w3.org/2000/svg'
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path d='M21.8701 6.96H2.48C2.21 6.96 2 6.74 2 6.48C2 6.22 2.22 6 2.48 6H21.8701C22.1401 6 22.3501 6.22 22.3501 6.48C22.3501 6.74 22.1301 6.96 21.8701 6.96Z' />
    <path d='M7.48 13C7.21 13 7 12.78 7 12.52C7 12.26 7.22 12.04 7.48 12.04H16.52C16.79 12.04 17 12.26 17 12.52C17 12.78 16.78 13 16.52 13H7.48Z' />
    <path d='M14.52 19H9.48C9.21 19 9 18.78 9 18.52C9 18.26 9.22 18.04 9.48 18.04H14.52C14.79 18.04 15 18.26 15 18.52C15 18.78 14.78 19 14.52 19Z' />
  </svg>
);
export default SvgFilter;
